import React from 'react';

export default function GrainOverlay() {
  return <div className="grain-overlay" aria-hidden="true" />;
}
